import type { DeviceGroupAttribute, GraphPath, Layout } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SavePathDefaultLayoutCommand {
  groupBy: DeviceGroupAttribute;
  layout: Layout;
  path: GraphPath;
}

export const savePathDefaultLayout: GraphCommandFactory<
  SavePathDefaultLayoutCommand
> = (cmdContext) => async (command) => {
  await cmdContext.api.request({
    url: '/graphs/default-layout',
    method: 'POST',
    data: {
      layout: command.layout,
      path: command.path,
      groupBy: command.groupBy,
    },
  });

  cmdContext.updateState((draft) => {
    draft.pathLayouts[command.groupBy][command.path] = command.layout;
  });
};
